import React from 'react';
import classNames from 'classnames';

import css from './IconFilter.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconFilter = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
    className={classes}
    width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2467_1402)">
        <path
          d="M1.71289 12H9.42718"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.71289 20.0894H17.1415"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5703 12H22.2846"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.286 3.91028H6.85742"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.71289 3.91078C1.71289 5.5565 2.6386 6.48221 4.28432 6.48221C5.93003 6.48221 6.85575 5.5565 6.85575 3.91078C6.85575 2.26507 5.93003 1.33936 4.28432 1.33936C2.6386 1.33936 1.71289 2.26507 1.71289 3.91078Z"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1426 20.0894C17.1426 21.7351 18.0683 22.6608 19.714 22.6608C21.3597 22.6608 22.2854 21.7353 22.2854 20.0895C22.2854 18.4437 21.3597 17.5179 19.714 17.5179C18.0683 17.5179 17.1426 18.4437 17.1426 20.0894Z"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.46875 12C9.46875 13.6457 10.3945 14.5714 12.0402 14.5714C13.6859 14.5714 14.6116 13.6457 14.6116 12C14.6116 10.3543 13.6859 9.42859 12.0402 9.42859C10.3945 9.42859 9.46875 10.3543 9.46875 12Z"
          stroke="white"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2467_1402">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconFilter;
